import {computed, ref} from 'vue'
import type {Ref} from 'vue'

export const useSearch = (resources: Ref<Resource[]>) => {
  const search = ref('')
  const items = computed((): Resource[] => {
    if (!search.value) return resources.value
    const term = search.value.toLowerCase()
    return resources.value.filter(
      item =>
       (item.title && item.title.toLowerCase().includes(term)) ||
       (item.description && item.description.toLowerCase().includes(term))
    )})
  return {
    search,
    items,
  }
}
